import React from "react";
import { Row, Col, Button, Card, Input, Table, Space } from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import "./style/style.css";

const { Search } = Input;

const assignStatusUnReg = (record) => {
  if (record?.approval_status === "rejected") {
    return "Rejected";
  } else if (
    record?.approval_status === null &&
    record?.submission_type === "submitted"
  )
    return "Awaiting Approval";
  else if (record?.status !== null) return record?.status?.toUpperCase();
  else return "-";
};

const assignStatusRegistered = (record) => {
  if (
    record?.status === "registered" &&
    record?.change_requests[0]?.approval_status === null &&
    record?.change_requests[0]?.status !== null
  ) {
    return <span>Awaiting Approval</span>;
  } else if (
    record?.status === "registered" &&
    record?.change_requests[0]?.approval_status === "APPROVED"
  ) {
    if (record.property_owners?.[0]?.objections?.[0]?.status === "submitted") {
      return <span>Objection Submitted</span>;
    } else if (
      record.property_owners?.[0]?.objections?.[0]?.status === "sent"
    ) {
      return <span>Objection Sent to TI</span>;
    } else {
      return <span>PH9 issued</span>;
    }
  } else if (
    record?.status === "registered" &&
    record?.change_requests[0]?.approval_status === "REJECTED"
  ) {
    return <span>CRF Request Declined</span>;
  } else if (record?.status !== null) {
    return record?.status?.charAt(0)?.toUpperCase() + record?.status.slice(1);
  } else return "-";
};

const PaginationDisplay = (props) => {
  const [searchedColumn, setSearchedColumn] = React.useState("");
  const searchInput = React.useRef(null);

  const getColumnconfig = (
    tableName,
    searchedColumn,
    setSearchedColumn,
    searchInput,
    history
  ) => {
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters, selectedKeys, confirm, dataIndex) => {
      clearFilters();
      handleSearch(selectedKeys, confirm, dataIndex);
    };

    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
            // zIndex: 100,
          }}
        >
          <Input
            ref={searchInput}
            placeholder={`Search`}
            value={selectedKeys[0]}
            onChange={(e) => {
              if (
                e?.target?.value?.length === 0 ||
                e?.target?.value?.trim()?.length > 0
              )
                setSelectedKeys(e.target.value ? [e.target.value] : []);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
              marginBottom: 8,
              display: "block",
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() =>
                clearFilters &&
                handleReset(clearFilters, selectedKeys, confirm, dataIndex)
              }
              size="small"
              style={{
                width: 90,
              }}
            >
              Reset
            </Button>
            {/* <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({
                  closeDropdown: false,
                });
                setSearchedColumn(dataIndex);
              }}
            >
              Filter
            </Button> */}
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? "#1890ff" : undefined,
          }}
        />
      ),
      // onFilter: (value, record) =>
      //   record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (text ? text.toString() : "") : text,
    });

    switch (tableName) {
      case "registeredProperties":
        return [
          {
            title: "Owner Name",
            dataIndex: "property_owners",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "District",
            dataIndex: "district",
            width: "10%",
            filters: !props?.isDistrictAdmin && props?.filterMetaData?.districts,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Zone",
            dataIndex: "zone",
            width: "10%",
            filters: props?.filterMetaData?.zones,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "ETO",
            dataIndex: "eto_name",
            width: "10%",
            ...getColumnSearchProps("eto_name"),
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Circle",
            dataIndex: "circle",
            width: "10%",
            filters: props?.filterMetaData?.circles,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Tax Inspector",
            dataIndex: "property_inspector",
            width: "10%",
            ...getColumnSearchProps("property_inspector"),
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Highway",
            dataIndex: "highway_name",
            width: "10%",
            render: (data, record) =>
              {
                return record?.highway?.name
              }
          },
          {
            title: "Address",
            dataIndex: "address",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "PIN",
            dataIndex: "pin",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Status",
            dataIndex: "status",
            width: "10%",
            render: (data, record) =>
            [undefined, null].includes(data) ? "-" : data,
            filters: [
              {
                text: "Awaiting Approval",
                value: "Awaiting Approval",
              },
              {
                text: "Objection Submitted",
                value: "Objection Submitted",
              },
              {
                text: "Objection Sent to TI",
                value:  "Objection Sent to TI",
              },
              {
                text: "PH9 issued",
                value: "PH9 issued",
              },
              {
                text: "CRF Request Declined",
                value: "CRF Request Declined",
              },
              {
                text: "Registered",
                value: "Registered",
              },
            ],
          },
        ];
      case "unregisteredProperties":
        return [
          {
            title: "Property#",
            dataIndex: "id",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "District",
            dataIndex: "districtName",
            width: "10%",
            filters: !props?.isDistrictAdmin && props?.filterMetaData?.districts,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Zone",
            dataIndex: "zoneName",
            width: "10%",
            filters: props?.filterMetaData?.zones,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Circle",
            dataIndex: "circleName",
            width: "10%",
            filters: props?.filterMetaData?.circles,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Highway",
            dataIndex: "highway_name",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Location",
            dataIndex: "locationName",
            width: "10%",
            render: (data, record) =>
              `${record?.longitude},${record?.latitude}`,
          },
          {
            title: "Status",
            dataIndex: "status",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
            filters: [
              {
                text: "Awaiting Approval",
                value: "Awaiting Approval",
              },
              {
                text: "Rejected",
                value: "Rejected",
              },
            ],
          },
        ];
      case "users":
        return [
          {
            title: "Name",
            dataIndex: "fullName",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Position",
            dataIndex: "position",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
            filters: [
              {
                text: "Tax Inspector",
                value: 1,
              },
              {
                text: "ETO",
                value: 2,
              },
            ],
          },
          {
            title: "Email",
            dataIndex: "email",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Phone",
            dataIndex: "phone",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "District",
            dataIndex: "district",
            width: "10%",
            filters: !props?.isDistrictAdmin && props?.filterMetaData?.districts,
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Status",
            dataIndex: "status",
            width: "10%",
            render: (flag) =>
              [undefined, null].includes(flag) ? (
                "-"
              ) : flag ? (
                <span style={{ color: "green" }}>Active</span>
              ) : (
                <span style={{ color: "red" }}>Inactive</span>
              ),
            filters: [
              {
                text: "Active",
                value: 1,
              },
              {
                text: "Inactive",
                value: 2,
              },
            ],
          },
        ];
      case "etos":
        return [
          {
            title: "Name",
            dataIndex: "fullName",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Email",
            dataIndex: "email",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Phone",
            dataIndex: "phone",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "District",
            dataIndex: "districts",
            filters: !props?.isDistrictAdmin && props?.filterMetaData?.districts,
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data)
                ? "-"
                : data?.length > 0
                ? data
                : "-",
          },
          {
            title: "Zones",
            dataIndex: "zones",
            filters: props?.filterMetaData?.zones,
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data)
                ? "-"
                : data?.length > 0
                ? data
                : "-",
          },
          {
            title: "Status",
            dataIndex: "status",
            // ...getColumnSearchProps('status'),
            width: "10%",
            render: (flag) =>
              [undefined, null].includes(flag) ? (
                "-"
              ) : flag === "Active" ? (
                <span style={{ color: "green" }}>Active</span>
              ) : (
                <span style={{ color: "red" }}>Inactive</span>
              ),
            filters: [
              {
                text: "Active",
                value: 1,
              },
              {
                text: "Inactive",
                value: 2,
              },
            ],
          },
        ];
      case "taxInspectors":
        return [
          {
            title: "Name",
            dataIndex: "fullName",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Email",
            dataIndex: "email",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Phone",
            dataIndex: "phone",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "District",
            dataIndex: "districts",
            // ...getColumnSearchProps('districts'),
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data)
                ? "-"
                : data?.length > 0
                ? data
                : "-",
            filters: !props?.isDistrictAdmin && props?.filterMetaData?.districts,
          },
          {
            title: "Circle",
            dataIndex: "circles",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data)
                ? "-"
                : data?.length > 0
                ? data
                : "-",
            filters: props?.filterMetaData?.circles,
            // ...getColumnSearchProps('circles'),
          },
          {
            title: "Status",
            dataIndex: "status",
            width: "10%",
            render: (flag) =>
              [undefined, null].includes(flag) ? (
                "-"
              ) : flag === "Active" ? (
                <span style={{ color: "green" }}>Active</span>
              ) : (
                <span style={{ color: "red" }}>Inactive</span>
              ),
            // ...getColumnSearchProps('status'),
            filters: [
              {
                text: "Active",
                value: 1,
              },
              {
                text: "Inactive",
                value: 2,
              },
            ],
          },
        ];
      case "lookupData":
        return [
          {
            title: "District",
            dataIndex: "District",
            width: "10%",
          },
          {
            title: "Tehsil",
            dataIndex: "Tehsil",
            width: "10%",
            filters: props?.filterMetaData?.tehsiles,
          },
          {
            title: "Qanoongoi",
            dataIndex: "Qanoongoi",
            width: "10%",
          },
          {
            title: "Mouza",
            dataIndex: "Mouza",
            width: "10%",
            filters: props?.filterMetaData?.mouzas
          },
          {
            title: "Classification",
            dataIndex: "Classification",
            width: "10%",
            render: (data, record) =>
              data,
          },
          {
            title: "Location",
            dataIndex: "Location",
            width: "10%",
          },
          {
            title: "Khasra No.",
            dataIndex: "Khasra Number",
            width: "10%",
          },
          {
            title: "DC Rate",
            dataIndex: "Dc Rate",
            width: "10%",
          },
          {
            title: "Units Of Measure",
            dataIndex: "unitsOfMeasure",
            width: "10%",
            render:(code)=>(code?code:"Marla(s)")
          },
          {
            title: "Structure Rate(Sq.ft)",
            dataIndex: "Structure Rate",
            width: "10%",
          },
          {
            title: "Circle",
            dataIndex: "Circle",
            width: "10%",
          },
          {
            title: "Zone",
            dataIndex: "Zone",
            width: "10%",
            filters: props?.filterMetaData?.zones,
          },
          {
            title: "Highway Name",
            dataIndex: "Highway Name",
            width: "100%",
          },
          {
            title: "Highway Code",
            dataIndex: "Highway Code",
            width: "10%",
            render:(code)=>(code?code:"---")
          },
          {
            title: "Effect From",
            dataIndex: "effectFrom",
            width: "10%",
          },

          {
            title: "Last Updated",
            dataIndex: "lastUpdated",
            width: "10%",
          },
          {
            title: "Actions",
            dataIndex: "Actions",
            width: "10%",
            render: (_, record) => (
              <Space size="middle">
                <a
                  onClick={() => {
                    history.push({
                      pathname: `/admin/update-lookup-record`,
                      state: record,
                    });
                  }}
                >
                  Update
                </a>
              </Space>
            ),
          },
        ];
      case "district_admins":
        return [
          {
            title: "Name",
            dataIndex: "fullName",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Email",
            dataIndex: "email",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "Phone",
            dataIndex: "phone",
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data) ? "-" : data,
          },
          {
            title: "District",
            dataIndex: "districts",
            filters: props?.filterMetaData?.districts,
            width: "10%",
            render: (data, record) =>
              [undefined, null].includes(data)
                ? "-"
                : data
                ? data
                : "-",
          },
          {
            title: "Status",
            dataIndex: "status",
            // ...getColumnSearchProps('status'),
            width: "10%",
            render: (flag) =>
              [undefined, null].includes(flag) ? (
                "-"
              ) : flag === "Active" ? (
                <span style={{ color: "green" }}>Active</span>
              ) : (
                <span style={{ color: "red" }}>Inactive</span>
              ),
            filters: [
              {
                text: "Active",
                value: 1,
              },
              {
                text: "Inactive",
                value: 2,
              },
            ],
          },
        ];
      
      default:
        return [
          {
            title: "District",
            dataIndex: "district",
            width: "10%",
          },
        ];
    }
  };

  const dataMapper = (tableName, initialData) => {
    /**
     * To solve problem of search
     * Map data for display before sending it to table
     * Perform render method here.
     */
    const mapZones = (zonesList) => {
      let zones = "";
      zonesList?.forEach((element, index) => {
        zones =
          zones +
          `${element?.name}${index !== zonesList?.length - 1 ? "," : ""}`;
      });
      return zones;
    };
    const mapCircles = (circlesList) => {
      let circles = "";
      circlesList?.forEach((element, index) => {
        circles =
          circles +
          `${element?.name}${index !== circlesList?.length - 1 ? "," : ""}`;
      });
      return circles;
    };
    const mapDistrict = (districtList) => {
      let districts = "";
      districtList?.forEach((element, index) => {
        districts =
          districts +
          `${element?.name}${index !== districtList?.length - 1 ? "," : ""}`;
      });
      return districts;
    };

    switch (tableName) {
      case "users":
        return initialData;
      case "lookupData":
        return initialData?.map((each) => ({
          ...each,
          unitsOfMeasure: each ? each["Units of Measure"] : "-",
          effectFrom: each?.effect_from
            ? moment(each?.effect_from).format("DD-MMM-YYYY")
            : "-" /*effect_from saved in ISOString format*/,
          lastUpdated: each
            ? moment(each["Last Updated"]).format("DD-MMM-YYYY")
            : "-",
        }));
      case "registeredProperties":
        return initialData?.map((each, index) => ({
          ...each,
          highway_name: each?.zone?.name ? each?.zone?.name : "-",
          property_inspector: each?.property_inspector?.user?.full_name
            ? each?.property_inspector?.user?.full_name
            : "-",
          circle: each?.circle?.name ? each?.circle?.name : "-",
          eto_name: each?.user?.full_name ? each?.user?.full_name : "-",
          zone: each?.zone?.name ? each?.zone?.name : "-",
          district: each?.district?.name ? each?.district?.name : "-",
          property_owners:
            each?.property_owners_names !== ""
              ? each?.property_owners_names
              : "-",
          status: assignStatusRegistered(each),
        }));
      case "unregisteredProperties":
        return initialData?.map((each, index) => ({
          ...each,
          propertyNumber: index + 1,
          districtName: each?.district?.name,
          circleName: each?.circle.name ? each?.circle.name : "-",
          zoneName: each?.zone?.name ? each?.zone?.name : "-",
          highway_name: each?.highway?.name ? each?.highway?.name : "-",
          status: assignStatusUnReg(each),
        }));
      case "etos":
        return initialData?.map((each) => ({
          ...each,
          status: each?.status ? "Active" : "Inactive",
          zones: mapZones(each?.zones),
          districts: mapDistrict(each?.districts),
        }));
      case "taxInspectors":
        return initialData?.map((each) => ({
          ...each,
          status: each?.status ? "Active" : "Inactive",
          circles: mapCircles(each?.circles),
          districts: mapDistrict(each?.districts),
        }));
      case "district_admins":
        return initialData?.map((each) => ({
          ...each,
          status: each?.status ? "Active" : "Inactive",
          districts: each?.district?.name,
        }));
      default:
        return initialData;
    }
  };

  return (
    <Table
      bordered={true}
      scroll={{ x: true }}
      columns={getColumnconfig(
        props?.tableName,
        searchedColumn,
        setSearchedColumn,
        searchInput,
        props.history
      )}
      dataSource={dataMapper(props?.tableName, props?.data)}
      pagination={false}
      onRow={(r) => ({
        onClick: () => {
          props?.onRowClick(r);
        },
      })}
      {...props}
      className="adminTable"
    />
  );
};

const TableSearch = ({
  data,
  sendRequestParams,
  tableName,
  onRowClick,
  resetLookupState,
  resetLookupParentState,
  isDistrictAdmin = false,
  ...props
}) => {
  const styles = {
    filters: { marginBottom: "10px" },
  };
  //transform filterObject in more readable manner ,remove irregularity from key.
  const transformFilterObject = (filterBody) => {
    switch (tableName) {
      case "registeredProperties":
        return {
          eto: [undefined, null].includes(filterBody["eto_name"])
            ? null
            : filterBody["eto_name"][0],
          ti: [undefined, null].includes(filterBody["property_inspector"])
            ? null
            : filterBody["property_inspector"][0],
          circles: [undefined, null].includes(filterBody?.circle)
            ? []
            : filterBody?.circle,
          districts: [undefined, null].includes(filterBody?.district)
            ? []
            : filterBody?.district,
          zones: [undefined, null].includes(filterBody?.zone)
            ? []
            : filterBody?.zone,
          status: [undefined, null].includes(filterBody?.status)
            ? []
            : filterBody?.status,
        };
      case "unregisteredProperties":
        return {
          circles: [undefined, null].includes(filterBody?.circleName)
            ? []
            : filterBody?.circleName,
          districts: [undefined, null].includes(filterBody?.districtName)
            ? []
            : filterBody?.districtName,
          zones: [undefined, null].includes(filterBody?.zoneName)
            ? []
            : filterBody?.zoneName,
          status: [undefined, null].includes(filterBody?.status)
            ? []
            : filterBody?.status,
        };
      case "taxInspectors":
        return {
          circle: [undefined, null].includes(filterBody?.circles)
            ? []
            : filterBody?.circles,
          district: [undefined, null].includes(filterBody?.districts)
            ? []
            : filterBody?.districts,
          status:
            [undefined, null].includes(filterBody?.status) ||
            filterBody?.status?.length > 1
              ? null
              : filterBody?.status[0] === 1
              ? true
              : false,
        };
      case "etos":
        return {
          zone: [undefined, null].includes(filterBody?.zones)
            ? []
            : filterBody?.zones,
          district: [undefined, null].includes(filterBody?.districts)
            ? []
            : filterBody?.districts,
          status:
            [undefined, null].includes(filterBody?.status) ||
            filterBody?.status?.length > 1
              ? null
              : filterBody?.status[0] === 1
              ? true
              : false,
        };
      case "users":
        return {
          position:
            [undefined, null].includes(filterBody?.position) ||
            filterBody?.position?.length > 1
              ? null
              : filterBody?.position[0],
          district: [undefined, null].includes(filterBody?.district)
            ? []
            : filterBody?.district,
          status:
            [undefined, null].includes(filterBody?.status) ||
            filterBody?.status?.length > 1
              ? null
              : filterBody?.status[0] === 1
              ? true
              : false,
        };
      case "district_admins":
        return {
          district: [undefined, null].includes(filterBody?.districts)
            ? []
            : filterBody?.districts,
          status:
            [undefined, null].includes(filterBody?.status) ||
            filterBody?.status?.length > 1
              ? null
              : filterBody?.status[0] === 1
              ? true
              : false,
        };
        default:
        return filterBody;
    }
  };
  const [tableFilter, setTableFilter] = React.useState(
    transformFilterObject({})
  );
  const [searchText, setSearchText] = React.useState("");
  const [tablePageSize, setTablePageSize] = React.useState(10);
  const [tableCurrentPage, setTableCurrentPage] = React.useState(1);
  const [prevFilter, setPrevFilter] = React.useState({
    searchText: "",
    size: 10,
  });
  const history = useHistory();

  const triggerTableSearch = (event) => {
    /**
     * fetch the searchString,pageSize, if change then send 0 as currentpage,
     * else send current-page
     */
    if (event === "") {
      setPrevFilter({ searchText: "", size: tablePageSize });
      sendRequestParams({
        searchText: "",
        size: tablePageSize,
        page: 1,
        filterBody: tableFilter,
      });
      setTableCurrentPage(1);
      setSearchText("");
    } else if (
      prevFilter?.searchText !== searchText ||
      prevFilter?.size !== tablePageSize
    ) {
      setPrevFilter({ searchText, size: tablePageSize });
      sendRequestParams({
        searchText,
        size: tablePageSize,
        page: 1,
        filterBody: tableFilter,
      });
      setTableCurrentPage(1);
    } else {
      sendRequestParams({
        searchText,
        size: tablePageSize,
        page: tableCurrentPage,
        filterBody: tableFilter,
      });
    }
  };

  const triggerPaginationAction = (page) => {
    //trigger from paginationAction,pass as prop to that component
    sendRequestParams({
      searchText,
      size: tablePageSize,
      page,
      filterBody: tableFilter,
    });
  };

  const triggerPageSizeAction = (pageSize) => {
    //for lookupTable only.
    setTableCurrentPage(1);
    sendRequestParams({
      searchText,
      size: pageSize,
      page: 1,
      filterBody: tableFilter,
    });
  };

  const triggerFilterAction = (filterBody) => {
    //map filter according to backend demand and then merge it.
    setTableFilter(filterBody);
    sendRequestParams({
      searchText,
      size: tablePageSize,
      page: 1,
      filterBody,
    });
  };

  const paginationController = (paginate, sort, filter, extras) => {
    const filterBody = transformFilterObject(sort);
    
    const { current, pageSize } = paginate;

    if (pageSize !== tablePageSize) {
      setTablePageSize(pageSize);
      triggerPageSizeAction(pageSize);
    } else if (current !== tableCurrentPage) {
      setTableCurrentPage(current);
      triggerPaginationAction(current);
    } else if (tableFilter !== filterBody) {
      triggerFilterAction(filterBody);
    } else {
    }
  };

  React.useEffect(() => {
    if (resetLookupState === true && tableName === "lookupData") {
      setTableCurrentPage(1);
      setTablePageSize(10);
      setSearchText("");
      resetLookupParentState(false);
    }
  }, [resetLookupState]);
  return (
    <div  className="logs-body" style={{ marginBottom: "20px" }}>
      <Row>
        {/* table header */}
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          style={styles.filters}
        ></Col>
        <Col xs={24} sm={24} lg={12} xl={12} style={styles.filters}>
          {["lookupData", "unregisteredProperties"].includes(tableName) || (
            <Search
              className="overlay-btn"
              placeholder="Search by name"
              onChange={(e) => setSearchText(e.target.value)}
              onSearch={(e) => triggerTableSearch(e)}
              value={searchText}
              style={{
                width: 200,
              }}
              allowClear={() => {}}
            />
          )}
        </Col>



        {/* table data */}
        <Col xs={24} sm={24} lg={24} xl={24}>
          <PaginationDisplay
            tableName={tableName}
            data={data?.data}
            onRowClick={onRowClick}
            style={{ marginBottom: "10px" }}
            history={history}
            pagination={{
              pageSize: tablePageSize,
              current: tableCurrentPage,
              currentPage: data?.pagination?.currentPage,
              total: data?.totalRecords || data?.pagination?.count,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30"],
              position: ["bottomRight"],
            }}
            onChange={paginationController}
            filterMetaData={props?.filterMetaData}
            loading={props?.loading}
            isDistrictAdmin={isDistrictAdmin}
          />
        </Col>

        {/* table footer */}
      </Row>
    </div>
  );
};

export default TableSearch;
